import { render } from "./taxCheckSb.vue?vue&type=template&id=4b4d0c3a&scoped=true"
import script from "./taxCheckSb.vue?vue&type=script&lang=js"
export * from "./taxCheckSb.vue?vue&type=script&lang=js"

import "./taxCheckSb.vue?vue&type=style&index=0&id=4b4d0c3a&lang=less&scoped=true"
import "./taxCheckSb.vue?vue&type=style&index=1&id=4b4d0c3a&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4d0c3a"]])

export default __exports__